type EnvRecord = { [key: string]: string | undefined }

type MongoUrlOptions = {
  dbName?: string
}

const parseMongoDirectConnectionOverride = (env: EnvRecord = process.env): boolean | null => {
  const rawValue = env.RB_MONGO_DIRECT_CONNECTION ?? env.MONGO_DIRECT_CONNECTION
  if (typeof rawValue !== "string") return null

  const value = rawValue.trim().toLowerCase()
  if (["1", "true", "yes", "on"].includes(value)) return true
  if (["0", "false", "no", "off"].includes(value)) return false
  return null
}

export const getMongoDirectConnection = (env: EnvRecord = process.env): boolean =>
  parseMongoDirectConnectionOverride(env) ??
  ["", "localhost", "127.0.0.1", "::1"].includes((env.DB_HOST ?? "").trim().toLowerCase())

export const getMongoUrl = (env: EnvRecord = process.env, options: MongoUrlOptions = {}): string => {
  const port = env.DB_PORT?.trim()
  if (!port) {
    throw new Error("Missing DB_PORT (required to build MongoDB connection URL)")
  }

  const host = env.DB_HOST?.trim() || "localhost"
  const baseUrl = `mongodb://${host}:${port}`
  const dbName = options.dbName?.trim()

  return dbName ? `${baseUrl}/${dbName}` : baseUrl
}
